<template>
    <div class="d-print-none" v-scroll="onScroll">

      <v-app-bar
        app
        color="white"
        dense flat
        class="appbar justify-space-between"
        ref="appBar" hide-on-scroll
        scroll-threshold="45"
      >
        <!--drawer icon for mobile-->
        <v-app-bar-nav-icon v-if="isMobile()" @click="drawer = !drawer"></v-app-bar-nav-icon>

        <!--logo-->
        <!--for larger screen sizes-->
        <v-col v-if="$vuetify.breakpoint.lgAndUp" cols="12" md="2" lg="2" class="pl-0" >
          <v-row no-gutters class="p-0">
          <router-link to="/">
            <v-img
              alt="HKLII Logo"
              class="mr-2"
              contain
              id="homehovericon"
              :src="require('../../assets/HKLII_logotype.svg')"
              max-width="80"
              max-height="35"
            />
          </router-link>

          <span class="caption text-small text-uppercase footergrey--text text--darken-1 pr-1 pl-3">{{$t('home.run_by')}}</span>
             <v-img
              alt="HKU Law Logo"
              align-self="end"
              class=""
              style="vertical-align:bottom !important;"
              contain
              :src="require('../../assets/HKULAW_logo.png')"
              min-width="40"
              max-width="50"
              :width="$vuetify.breakpoint.xs? '40px':'50px'" :height="$vuetify.breakpoint.xs?'25.25px':'25px'"
            />
            </v-row>
        </v-col>

        <router-link v-else to="/" >
          <v-img
            alt="HKLII Logo"
            class="mr-2"
            contain
            id="homehovericon"
            :src="require('../../assets/HKLII_logotype.svg')"
            max-width="80"
            max-height="35"
          />
        </router-link>

        <v-spacer v-if="$vuetify.breakpoint.mdOnly"></v-spacer>

        <!--buttons to pages-->
        <div class="d-flex align-center" v-if="$vuetify.breakpoint.mdOnly">
          <v-btn height="48px" dense text @click="$router.push('/databases')"> {{$t('database.dbs')}}</v-btn>
          <v-btn height="48px" dense text @click="$router.push('/about')"> {{$t('about.page_title')}}</v-btn>
          <v-btn height="48px" dense text @click="$router.push('/donors')"> {{$t('btntxt.ft_donors')}}</v-btn>
          <v-btn height="48px" dense text @click="$router.push('/liis')"> {{$t('btntxt.hd_liis')}}</v-btn>
        </div>
        <!--for larger screen sizes-->
        <v-col cols="12" md="5" lg="5" v-if="$vuetify.breakpoint.lgAndUp" class="pr-0 pl-xl-16">
          <div>
            <v-btn height="48px" dense text @click="$router.push('/databases')" class="px-3"> {{$t('database.dbs')}}</v-btn>
            <v-btn height="48px" dense text @click="$router.push('/about')" class="px-3"> {{$t('about.page_title')}}</v-btn>
            <v-btn height="48px" dense text @click="$router.push('/donors')" class="px-3"> {{$t('btntxt.ft_donors')}}</v-btn>
            <v-btn height="48px" dense text @click="$router.push('/liis')" class="px-3"> {{$t('btntxt.hd_liis')}}</v-btn>
          </div>
        </v-col>

        <v-spacer v-if="$vuetify.breakpoint.mdOnly||$vuetify.breakpoint.smOnly"></v-spacer>

        <!--lang selection-->
        <div v-if="$vuetify.breakpoint.smAndUp">
          <v-menu>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                text
                v-bind="attrs"
                v-on="on"
                class="my-0 mr-3 px-0"
                color="navlink"
                height="48px"
              >
                {{lang.title}}
                <v-icon dense right class="ml-0"> mdi-chevron-down </v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(lang, index) in langs"
                :key="index"
                @click="setLang(lang)"
              >
                <v-list-item-title>{{ lang.title }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <!-- <v-btn icon @click.stop="dialog = true"><v-icon>person</v-icon></v-btn> -->
        </div>

        <!--search bar on desktop-->
        <v-text-field
          style="min-width: 230px;"
          v-model="text"
          class="mx-0 my-0 mb-1"
          @click:append="go_search"
          @keydown.enter="go_search"
          hide-details solo flat
          background-color="rsidebg"
          append-icon="search"
          color="navlink"
          placeholder='e.g A v. B; "Wills Ordinance" AND gift*'
        >
        </v-text-field>

      </v-app-bar>
        

      <!--mobile nav drawer-->
      <v-navigation-drawer
        v-model="drawer"
        temporary fixed dense
        app disable-resize-watcher
      >

        <v-list class="pt-0">
          <v-subheader>
            <router-link to="/">
              <v-img
                  alt="HKLII Logo"
                  class="mr-2"
                  contain
                  :src="require('../../assets/HKLII_logotype.svg')"
                  max-width="70"
                  max-height="35"
                />
            </router-link>

            <!--translation button for xs on nav-->
            <v-row v-if="!$vuetify.breakpoint.smAndUp" class="mr-1" >
              <v-spacer></v-spacer>
                <v-menu offset-x>
                  <template v-slot:activator="{ on, attrs }">
                      <v-btn outlined small v-bind="attrs" v-on="on" color="navlink">
                        <v-icon small class="mr-4" color="navlink">translate</v-icon>
                        {{lang.title}}
                      </v-btn>
                    </template>

                    <v-list>
                      <v-list-item
                        v-for="(lang, index) in langs"
                        :key="index"
                        @click="setLang(lang)"
                      >
                        <v-list-item-title>{{ lang.title }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                </v-menu>
            </v-row>
          </v-subheader>

          <v-list-item @click="$router.push('/advancedsearch')" link class="mobilenavlist">
            <v-list-item-icon><v-icon>mdi-text-search</v-icon></v-list-item-icon>
            <v-list-item-title>{{ $t('search.advs.advanced') }}</v-list-item-title>
          </v-list-item>
          
          <v-list-group 
           prepend-icon="mdi-book-multiple-outline"
           :value="true"
           class="mobilenavlist"
           active-class="activemobilelist"
          >
            <template v-slot:activator>
               <div @click="$router.push('/databases')" >
                <v-list-item class="pl-0 pr-8">
                <v-list-item-title>{{ $t('database.dbs') }}</v-list-item-title>
                </v-list-item>
              </div>
            </template>
            
            <v-list-item
              v-for="item in dbs"
              :key="item.abbr"
              :to="{name:'databases', query:{'cat':item.abbr}}"
              link exact
              class="lsidebg mobilenavlist"
            >
              <v-list-item-icon> <v-icon class="ml-6">mdi-file-document-outline</v-icon> </v-list-item-icon>
              <v-list-item-title> {{item.label}}</v-list-item-title>
            </v-list-item>
          </v-list-group>

          <v-list-item @click="$router.push('/liis')" link class="mobilenavlist">
            <v-list-item-icon><v-icon>mdi-link-variant</v-icon></v-list-item-icon>
            <v-list-item-title>{{ $t('btntxt.hd_liis') }}</v-list-item-title>
          </v-list-item>

          <v-list-item @click="$router.push('/about')" link class="mobilenavlist">
            <v-list-item-icon><v-icon>mdi-information-outline</v-icon></v-list-item-icon>
            <v-list-item-title>{{ $t('about.page_title') }}</v-list-item-title>
          </v-list-item>

          <v-list-item @click="$router.push('/feedback')" link class="mobilenavlist">
            <v-list-item-icon><v-icon>mdi-email-outline</v-icon></v-list-item-icon>
            <v-list-item-title>{{ $t('btntxt.feedback') }}</v-list-item-title>
          </v-list-item>

          <v-list-item href="https://eform.giving.hku.hk/zend/online_donation/hong_kong_legal_information_institute" link class="mobilenavlist">
            <v-list-item-icon><v-icon>mdi-sprout</v-icon></v-list-item-icon>
            <v-list-item-title>{{ $t('btntxt.donate') }}</v-list-item-title>
          </v-list-item>

          <v-list-item @click="$router.push('/donors')" link class="mobilenavlist">
            <v-list-item-icon><v-icon>mdi-account-supervisor-circle-outline</v-icon></v-list-item-icon>
            <v-list-item-title>{{ $t('btntxt.ft_donors') }}</v-list-item-title>
          </v-list-item>

        </v-list>

        <template v-slot:append>
          <div class="pa-2">
            <p class="footergrey--text text-caption text-uppercase mb-2">{{$t('home.run_by')}}</p>
            <a href="https://www.hku.hk" target="_blank">
              <v-img
                alt="HKU Law Logo"
                align-self="end"
                class=""
                style="vertical-align:bottom !important;"
                contain
                :src="require('../../assets/HKULAW_logo.png')"
                min-width="40"
                max-width="85"
               
                :width="$vuetify.breakpoint.xs? '60px':'100px'" :height="$vuetify.breakpoint.xs?'25.25px':'35.77px'"
              /></a>

          </div>
        </template>


      </v-navigation-drawer>

    </div>
</template>

<script>
  import { Scroll } from 'vuetify/lib/directives/scroll'
  export default {
    name:'Header',
      directives: {
        Scroll,
      },
      data: () => ({
        text:'',
        dialog:false,
        langs:[
          {'title':'EN', value:'en'},
          {'title':'繁體', value:'tc'},
          {'title':'简体', value:'sc'},
        ],
        lang: {'title':'EN', value:'en'},
        drawer: null,
        token: null,
      }),

    methods:{
      setLang(item){
        // item: 'en' || 'tc' || 'sc'
        if (typeof item === 'object'){
          this.lang = item
        } else if (typeof item === 'string'){
          this.lang = this.langs.filter(lang => lang.value == item)[0] || this.langs[0]
        }
        this.$i18n.locale = this.lang.value
      },
      isMobile(){
        return this.$vuetify.breakpoint.smAndDown
      },
      go_search(){
        if (this.text.length > 0){
              this.quick_dialog = false
              this.$router.push({name:'search-results', query:{q:this.text}}) //,d:0
        }
      },
      onScroll() {
        // @hack: https://github.com/vuetifyjs/vuetify/issues/9993
        const { appBar } = this.$refs
        if (appBar.currentScroll < appBar.currentThreshold) {
          appBar.isActive = true
        }
      },
    },
    mounted(){
      this.setLang(sessionStorage.locale || 'en')
      if ('TOKEN' in sessionStorage){
          this.token = sessionStorage['TOKEN']
      }
    },
    computed:{
      dbs(){
        return  [
          {label: this.$i18n.t('home.judgments'), abbr:"C"},
          {label: this.$i18n.t('home.legislation'), abbr:"L"},
          {label: this.$i18n.t('database.others'), abbr:"O"},
        ]
      },
    }
  }
</script>

<style scoped lang="scss" >
  .nav {
    height: 44px;
  }

  #homehovericon {
    cursor: url("data:image/svg+xml,%3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' fill='grey' x='0px' y='0px' width='20px' height='20px' viewbox='0 0 20 20' xml:space='preserve'%3E %3Cpath d='M 12 3 L 20 9 V 21 H 15 V 14 H 9 V 21 H 4 V 9 L 12 3 Z'/%3E %3C/svg%3E"), pointer;
  }

  .activemobilelist{ /*dont lit up the icon colors at mobile nav databases*/
    color: rgba(0, 0, 0, 0.54) !important;
  }
  
  /*dropdown overwrite*/
  .theme--light.v-list{
    background: white;
  }

  .app-hklii.v-application .primary--text { /*overwrite the active class color set in app.vue, for mobile nav*/
    color: var(--v-liiblack-base) !important;
  }
</style>
